import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { mergeStyles } from '@uifabric/merge-styles';
import { getPalette } from 'owa-theme';

export default function getInfoBarLinkColorStyle(colorScheme: ColorScheme) {
    const textColor = colorScheme ? colorScheme.calDarkAlt : getPalette().themeDarkAlt;
    const hoverColor = colorScheme ? colorScheme.calDarker : getPalette().themeDarker;
    return mergeStyles({
        color: textColor,
        selectors: {
            ':hover': { color: hoverColor },
            ':active': { color: hoverColor },
        },
    });
}
